<template>
  <div>
    <breadcrumbPage></breadcrumbPage>
    <div class="content EC_width">
      <div class="leftContent">
        <div class="title">
          <span>{{ newInfo.title }}</span>
        </div>
        <div class="display_between" style="border-bottom: 1px solid #ddd;">
          <div class="showInfo">
            <span class="split">
              <img src="/image/icon/shizhong.png" />
              {{ formatTime(newInfo.publishtime, 'YYYY-MM-DD') }}
            </span>
            <span class="split">
              {{ newInfo.source }}
            </span>
            <span class="split">点击量:{{ newInfo.clickVolume }}</span>
          </div>
          <div v-if="newInfo.labelName != ''">
            <span v-bind:class="calculate(index)" v-for="(item, index) in (newInfo.labelName || '').split(',')"
              :key="'0' + index" @click="onsearch(item)">
              {{ item }}
            </span>
          </div>
          <div v-else></div>
        </div>
        <div class="mainTextWrap">
          <p class="mainText">
            <span v-html="contents"></span>
          </p>
          <div class="downInfor marginBottom10">
            <p>{{ newInfo.disclaimer }}</p>
          </div>
        </div>
        <div class="timeLine">
          <div class="flex1 display_between">
            <div class="display_center tipsHover" @click="clkNew(lastNew)" v-if="lastNew.title != ''">
              <div class="page_btn" style="margin-right: 10px;">
                &lt;
              </div>
              <div>
                <a href="javascript:;" class="page_btn_active_link">
                  <span style="font-weight: bold;">上一篇：</span>
                  {{ ellipsis(lastNew.title, 18) }}
                </a>
              </div>
            </div>
            <div class="display_center tipsHover" @click="clkNew(nextNew)" v-if="nextNew.title != ''">
              <div>
                <a class="page_btn_active_link" href="javascript:;">
                  <span style="font-weight: bold;">下一篇：</span>
                  {{ ellipsis(nextNew.title, 18) }}
                </a>
              </div>
              <div class="page_btn page_btn_active" style="margin-left: 10px;">
                &gt;
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rightVideoList">
        <div class="rightVedioTitle display_between marginBottom20">
          <div class="leftTitle">相关课程推荐</div>
          <!-- <div>
                        <a href="javascript:;"><img src="/image/index/moreimg.png" class="marginRight5">更多</a>
                    </div> -->
        </div>
        <div class="videoWrap marginBottom30" style="cursor: pointer;" v-for="(item, index) in courseList"
          :key="'0' + index" @click="courseclick(item)">
          <img :src="item.acr_PictResUrl" alt="" width="300" height="169" />
          <div class="videoTitle">
            {{ item.title }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumbPage from '../home/breadcrumbPage';
import format from '@/assets/unit/unit.js';
export default {
  name: 'inforDetails',
  data() {
    return {
      apiData: {
        article: {
          data: {
            prelink: '',
            nextlink: ''
          }
        },
        course: {}
      },

      /** tianlianpei */
      newInfo: {},
      contents: '',
      lastNew: {
        id: 0,
        title: ''
      },
      nextNew: {
        id: 0,
        title: ''
      },
      column_Type: 0,
      courseList: [], //推荐课程
      crumbFirst: '',
      crumb2nd: '',
      crumbFirsturl: '',
      colorList: ['gl_gree_block', 'gl_red_block', 'gl_blue_block']
    };
  },
  methods: {
    getData() {
      var that = this;
      fetch('/data.json')
        .then(res => {
          return res.json();
        })
        .then(data => {
          that.apiData = data.inforDetails.data;
        })
    },

    /** tianlianpei */

    /**根据新闻ID获取新闻详情 */
    GetNewInfoById(id, column_Type) {
      let _this = this;
      _this.$loading.show({
        text: 'loading....',
        textStyle: {
          fontSize: '18px',
          color: '#0b8686'
        }
      });
      _this.httphelper
        .post('/api/NewApi/GetNewInfoById', {
          keyword: '',
          id: parseInt(id),
          parentID: 0,
          column_Type: parseInt(column_Type),
          pageIndex: 0,
          pageSize: 0
        })
        .then(res => {
          _this.$loading.hide();
          if (res.data.code == 200) {
            let newinfolist = res.data.data.gpSiteNewInfoViewsViews;
            if (newinfolist != null && newinfolist.length > 0) {
              _this.newInfo = newinfolist[0];
              _this.contents = _this.newInfo.contents
                .replace(/white-space:nowrap/g, 'white-space:pre-wrap')
                .replace(/<video /g, "<video @contextmenu.prevent='' ")
                .replace(/<audio /g, "<audio @contextmenu.prevent='' ");
            }
            _this.lastNew = res.data.data.lastNextPieceNewViews[0];
            _this.nextNew = res.data.data.lastNextPieceNewViews[1];
            _this.GetCourseRecommendPageList();
          }
        });
    },

    /**相关课程推荐 */
    GetCourseRecommendPageList() {
      let _this = this;
      this.labelName = this.newInfo.labelName.substring(0, this.newInfo.labelName.length - 1);
      _this.httphelper
        .post('/api/ArticleApi/GetCourseRecommendPageList', {
          year: '',
          period: '',
          id: 0,
          keywords: _this.newInfo.labelName,
          recommendNumber: 4
        })
        .then(res => {
          if (res.data.code == 200) {
            _this.courseList = res.data.data;
          }
        });
    },

    clkNew(e) {
      if (document.body.scrollTop) {
        document.body.scrollTop = 0;
      } else {
        document.documentElement.scrollTop = 0;
      }
      this.$router.push({
        path: '/home/inforDetails',
        query: {
          id: e.id,
          column_Type: this.column_Type
        }
      });
      window.location.reload();
    },

    /** 课程跳转*/
    courseclick(item) {
      let id = item.courseInfoId == 0 ? item.id : item.courseInfoId;
      let url = this.httphelper.IsDebugCgphome() + '/detail?courseId=' + id;
      window.open(url);
    },
    formatTime(datatime, timeformat) {
      return format(datatime, timeformat);
    },
    onsearch(keywords) {
      const { href } = this.$router.resolve({
        path: '/home/searchPage?',
        query: {
          labelname: keywords
        }
      });
      window.open(href, '_blank');
    },
    calculate(index) {
      var nm = this.colorList[Math.floor(index % 3)];
      return nm;
    }
  },
  created() {
    if (this.$route.query.column_Type != undefined) {
      this.column_Type = parseInt(this.$route.query.column_Type);
    }
    if (localStorage.getItem('Inforlist_param_' + this.column_Type)) {
      let Inforlist_param = JSON.parse(localStorage.getItem('Inforlist_param_' + this.column_Type));
      this.$route.matched.forEach(element => {
        if (element.name == Inforlist_param.goroutename) element.meta.breadcrumbTitle = Inforlist_param.title;
      });
    }

    this.getData();
  },
  mounted() {
    if (this.$route.query.column_Type != undefined) {
      this.column_Type = parseInt(this.$route.query.column_Type);
    }

    this.GetNewInfoById(this.$route.query.id, this.column_Type);
  },
  components: {
    breadcrumbPage
  }
};
</script>

<style scoped>
.content {
  padding-top: 30px;
  display: flex;
  flex: 1;
}

.leftContent {
  flex: 1;
}

.title {
  font-size: 26px;
  font-weight: bold;
  margin-bottom: 30px;
}

.title span {
  padding: 0 20px;
  border-left: 4px solid #0b8686;
}

.showInfo {
  height: 54px;

  line-height: 54px;
}

.split {
  font-size: 14px;
  position: relative;
  margin-right: 20px;
}

.mainTextWrap {
  padding-top: 30px;
  border-bottom: 1px solid #ddd;
}

.maintitle {
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 15px;
}

.mainText {
  /* font-size: 14px; */
  font-family: 'microsoft yahei';
  font-weight: 400;
  color: #000000;
  line-height: 35px;
  margin-bottom: 44px;
}

.mainImg {
  margin-bottom: 44px;
}

.downInfor {
  color: #ccc;
}

.gree_block,
.red_block,
.blue_block {
  display: inline-block;
  padding: 4px 8px;
  font-size: 12px;
  margin-right: 5px;
}

.gree_block {
  border: 1px solid #469a97;
  color: #469a97;
}

.red_block {
  border: 1px solid #cc6d6e;
  color: #cc6d6e;
}

.blue_block {
  border: 1px solid #417393;
  color: #417393;
}

.timeLine {
  height: 80px;
  line-height: 80px;
}

.page_btn {
  color: #999;
  cursor: pointer;
  display: inline-block;
  width: 22px;
  height: 22px;
  text-align: center;
  line-height: 22px;
  border-radius: 22px;
  border: 1px solid #ccc;
}

.page_btn_active {}

/* 右侧样式设置 */
.rightVideoList {
  width: 310px;
  margin-left: 50px;
}

/* 右面视频列表样式 */

.rightVedioTitle {
  height: 56px;
  line-height: 56px;
  border-bottom: 1px solid #ddd;
}

.leftTitle {
  font-size: 20px;
  font-weight: bold;
  border-bottom: 1px solid #333;
}

.videoWrap video {
  width: 100%;
}

.videoTitle {
  font-size: 16px;
  margin-top: 12px;
}

.tipsHover:hover .page_btn_active_link {
  color: #0b8686;
}

.tipsHover:hover .page_btn {
  background: #0b8686;
  color: #fff;
  border: 1px solid #0b8686;
}
</style>
